import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import Button from '../../../components/buttons/Button';
import FAQsTable from '../../../modules/faqs/components/FAQsTable';

const FAQs = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle } = useModuleTableHelpers({
    route: 'admin/cms/faqs',
    withBreadcrumb: true,
    breadcrumbTitle: t('faqs'),
    withPagination: true,
    queryKey: 'faqs'
  });

  const tableHeaders = [
    { label: t('faq_question') },
    { label: t('order') },
    { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="fuelTypes-page-container">
      <ListHeader customClass='table_filters'>
        <Button text={t('create_faq')} link="/faqs/create-faq" />
      </ListHeader>
      <FAQsTable tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_faqs_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default FAQs;
